import Firebase from 'firebase';

let config = {
  apiKey: "AIzaSyCGvJo7y0qOCUNAc7TinVAFlEWrhjV4gCQ",
  authDomain: "stocker-6482a.firebaseapp.com",
  databaseURL: "https://stocker-6482a.firebaseio.com",
  storageBucket: "stocker-6482a.appspot.com"
};

Firebase.initializeApp(config);

let initializeFirebase = function(){
  return new Promise((resolve, reject) => {
    let unsubscribe = Firebase.auth().onAuthStateChanged(() => {
      resolve(Firebase.auth().currentUser);
      unsubscribe();
    });
  });
}

let db = Firebase.database();
let stocks = db.ref('stocks');
let notes = db.ref('notes');

export {
  initializeFirebase,

  db,
  stocks,
  notes
}



// WEBPACK FOOTER //
// ./src/config.js